import routeTo from '../../router/utils/routeTo';

export const menuItems = (t: any) => {
  return [
    {
      icon: 'search',
      title: t('Oportunities'),
      route: routeTo('dashboard.opportunities'),
      isMobileOnly: true,
    },
    {
      icon: 'home',
      title: t('Home'),
      route: routeTo('dashboard.vacancies'),
      isMobileOnly: true,
    },
    {
      icon: 'work',
      title: t('My Resume'),
      route: routeTo('dashboard.professional.info'),
      isMobileOnly: true,
    },
    {
      icon: 'account_circle',
      title: t('My Profile'),
      route: routeTo('dashboard.account'),
      isMobileOnly: true,
    },
    {
      icon: 'folder',
      title: t('Documents'),
      route: routeTo('dashboard.documents'),
      isMobileOnly: true,
    },
    {
      icon: 'group',
      title: t('Dependents'),
      route: routeTo('dashboard.dependents'),
      isMobileOnly: true,
    },
    {
      icon: 'group_work ',
      title: t('Group Dynamics'),
      route: routeTo('dashboard.groupInterviews'),
      isMobileOnly: true,
    },
    {
      icon: 'message',
      title: t('Messages'),
      route: routeTo('dashboard.messages'),
      isMobileOnly: true,
    },
  ];
};
